import { render, staticRenderFns } from "./PremiumDialog.vue?vue&type=template&id=eee3b59e&scoped=true&"
import script from "./PremiumDialog.vue?vue&type=script&lang=js&"
export * from "./PremiumDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee3b59e",
  null
  
)

export default component.exports